



























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { KsnTableData, KsnMonth } from "../table-data/KsnTableData"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"

@Component({})
export default class ReportKsn extends Vue {
    @Prop({ required: true }) tableData!: KsnTableData
    @Prop({ default: null }) edate!: string | null
    @Prop({ default: false }) roundUp!: boolean
    @Prop({ default: null }) roundUpTo!: number | null

    private currentMonthIndex = 0

    get currentMonth(): KsnMonth | null {
        return this.tableData.months[this.currentMonthIndex] ?? null
    }

    get edateFormatted(): string {
        if (!this.edate) return ''
        try {
            const [y, m, d] = this.edate.split('-')
            return `${d}.${m}.${y}г.`
        } catch {
            return this.edate
        }
    }

    private fmt(val: number): string {
        if (val === 0 || val === null || val === undefined) return ''
        if (this.roundUp && this.roundUpTo != null) {
            const decimals = Number(this.roundUpTo)
            const roundUpFactor = Math.pow(10, decimals)
            const rounded = Math.round(val * roundUpFactor) / roundUpFactor
            return formatDigitsGrouping(rounded.toFixed(decimals))
        }
        const str = val.toString()
        const dotIdx = str.indexOf('.')
        if (dotIdx !== -1 && str.length - dotIdx - 1 > 5) {
            return formatDigitsGrouping(parseFloat(val.toFixed(5)))
        }
        return formatDigitsGrouping(val)
    }

    private fmtTotal(daily: Record<string, number>, dates: string[]): string {
        const total = dates.reduce((sum, d) => sum + (daily[d] || 0), 0)
        if (total === 0) return ''
        if (this.roundUp && this.roundUpTo != null) {
            const decimals = Number(this.roundUpTo)
            return formatDigitsGrouping(total.toFixed(decimals))
        }
        const totalStr = total.toString()
        const dotIdx = totalStr.indexOf('.')
        if (dotIdx !== -1 && totalStr.length - dotIdx - 1 > 5) {
            return formatDigitsGrouping(parseFloat(total.toFixed(5)))
        }
        return formatDigitsGrouping(total)
    }
}
